import { render } from "./ProgressTracker.vue?vue&type=template&id=08b5360c&scoped=true"
import script from "./ProgressTracker.vue?vue&type=script&lang=js"
export * from "./ProgressTracker.vue?vue&type=script&lang=js"

import "./ProgressTracker.vue?vue&type=style&index=0&id=08b5360c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b5360c"]])

export default __exports__